import { render, staticRenderFns } from "./UserGroupSearch.vue?vue&type=template&id=18c8dc36&scoped=true"
import script from "./UserGroupSearch.vue?vue&type=script&lang=js"
export * from "./UserGroupSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c8dc36",
  null
  
)

export default component.exports